export const MM_PER_INCH = 25.4;
export const DPI_DISPLAY = 72; // https://en.wikipedia.org/wiki/Dots_per_inch#Computer_monitor_DPI_standards
